<template>
  <transition 
    :name="transitionName" 
    :mode="mode" 
    :duration="duration"
    @before-enter="beforeEnter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @after-leave="afterLeave"
  >
    <div :key="componentKey">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
import { ANIMATION_DURATIONS } from '../utils/animations';

export default {
  name: 'TransitionView',
  props: {
    name: {
      type: String,
      default: 'fade'
    },
    mode: {
      type: String,
      default: 'out-in'
    },
    duration: {
      type: [Number, Object],
      default: ANIMATION_DURATIONS.NORMAL
    },
    forceKey: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    transitionName() {
      return `app-${this.name}`;
    },
    componentKey() {
      return this.forceKey || Date.now();
    }
  },
  methods: {
    beforeEnter(el) {
      this.$emit('before-enter', el);
    },
    afterEnter(el) {
      this.$emit('after-enter', el);
    },
    beforeLeave(el) {
      this.$emit('before-leave', el);
    },
    afterLeave(el) {
      this.$emit('after-leave', el);
    }
  }
};
</script>

<style scoped>
/* Fade transition */
.app-fade-enter-active,
.app-fade-leave-active {
  transition: opacity v-bind(typeof duration === 'object' ? duration.enter + 'ms' : duration + 'ms') ease;
}
.app-fade-enter-from,
.app-fade-leave-to {
  opacity: 0;
}

/* Slide right transition */
.app-slide-right-enter-active,
.app-slide-right-leave-active {
  transition: all v-bind(typeof duration === 'object' ? duration.enter + 'ms' : duration + 'ms') ease;
}
.app-slide-right-enter-from {
  transform: translateX(-20px);
  opacity: 0;
}
.app-slide-right-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

/* Slide left transition */
.app-slide-left-enter-active,
.app-slide-left-leave-active {
  transition: all v-bind(typeof duration === 'object' ? duration.enter + 'ms' : duration + 'ms') ease;
}
.app-slide-left-enter-from {
  transform: translateX(20px);
  opacity: 0;
}
.app-slide-left-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

/* Slide up transition */
.app-slide-up-enter-active,
.app-slide-up-leave-active {
  transition: all v-bind(typeof duration === 'object' ? duration.enter + 'ms' : duration + 'ms') ease;
}
.app-slide-up-enter-from {
  transform: translateY(20px);
  opacity: 0;
}
.app-slide-up-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

/* Zoom transition */
.app-zoom-enter-active,
.app-zoom-leave-active {
  transition: 
    transform v-bind(typeof duration === 'object' ? duration.enter + 'ms' : duration + 'ms') ease, 
    opacity v-bind(typeof duration === 'object' ? duration.enter + 'ms' : duration + 'ms') ease;
}
.app-zoom-enter-from,
.app-zoom-leave-to {
  transform: scale(0.95);
  opacity: 0;
}
</style> 